import { render } from "./InvoiceStatus.vue?vue&type=template&id=c990a914&scoped=true&ts=true"
import script from "./InvoiceStatus.vue?vue&type=script&lang=ts"
export * from "./InvoiceStatus.vue?vue&type=script&lang=ts"

import "./InvoiceStatus.vue?vue&type=style&index=0&id=c990a914&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@5.9.3__webpack@5.108.4_postcss@8.5.22_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c990a914"]])

export default __exports__